/**
 * WebSocket 客户端
 */

import { io, Socket } from 'socket.io-client';
import type { LogEntry, Status } from './api';

const WS_URL = import.meta.env.PROD ? '' : 'http://localhost:3001';

class SocketClient {
  private socket: Socket | null = null;
  private listeners: Map<string, Set<Function>> = new Map();

  connect() {
    if (this.socket?.connected) return;

    this.socket = io(WS_URL, {
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('[WebSocket] 已连接');
    });

    this.socket.on('disconnect', () => {
      console.log('[WebSocket] 已断开');
    });

    this.socket.on('status', (status: Status) => {
      this.emit('status', status);
    });

    this.socket.on('log', (log: LogEntry) => {
      this.emit('log', log);
    });
  }

  disconnect() {
    this.socket?.disconnect();
    this.socket = null;
  }

  on(event: string, callback: Function) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  off(event: string, callback: Function) {
    this.listeners.get(event)?.delete(callback);
  }

  private emit(event: string, data: any) {
    this.listeners.get(event)?.forEach(cb => cb(data));
  }
}

export const socketClient = new SocketClient();
